import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const ContentContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;

  @media (max-width: 576px) {
    flex-direction: column;
  }
  ${(props) =>
    props.center &&
    css`
      justify-content: center;
    `}
`;

export const ChallengeDescription = styled.p`
  color: ${colors.darkGray};
  white-space: pre-wrap;
  font-size: 14px;
  word-wrap: break-word;
  word-break: break-all;
  & img {
    max-width: 100%;
  }
`;

export const ChallengeLabel = styled.span`
  text-transform: uppercase;
  color: ${colors.gray2};
  font-weight: 300;
  font-size: 18px;
  margin-bottom: 10px;

  ${({ noMargin }) =>
    noMargin &&
    css`
      margin: 0;
    `}

  ${({ alignRight }) =>
    alignRight &&
    css`
      align-self: flex-end;
    `}

  ${({ noWrap }) =>
    noWrap &&
    css`
      white-space: nowrap;
    `}

    ${({ smallDevice }) =>
    smallDevice &&
    css`
      @media (max-width: 576px) {
        align-self: flex-start;
      }
    `}
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: flex-start;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};

      @media (max-width: 576px) {
        width: 100%;
      }
    `}

  ${({ center }) =>
    center &&
    css`
      flex-direction: row;
      justify-content: center;
    `}

  ${(props) =>
    props.right &&
    css`
      flex: 0 0 auto;
      margin-left: 20px;

      @media (max-width: 576px) {
        margin-left: 0;
      }
    `}
`;

export const SectionColumn = styled.div`
  display: flex;
  flex-direction: column;
  ${({ noGap }) =>
    !noGap &&
    css`
      gap: 1rem;
    `}
`;

export const AuthorAvatar = styled.div`
  border-radius: 50%;
  width: 35px;
  height: 35px;
  background-image: url(${(props) => props.image || ''});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
`;

export const AuthorContainer = styled.div`
  display: flex;
  color: ${colors.darkGray};
  align-items: center;
  font-size: 14px;
`;

export const AuthorName = styled.a`
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  text-decoration: none;
  padding-left: 10px;
  color: ${colors.darkGray};

  :hover {
    text-decoration: none;
    color: ${colors.darkGray};
  }
`;

export const MetaInfoRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
  width: 100%;
  margin-bottom: 20px;
`;

export const RatingAlignRow = styled.div`
  width: 100%;
  display: block;
  justify-content: end;

  @media (max-width: 576px) {
    justify-content: start;
  }
`;

export const SponsorLogo = styled.div`
  position: relative;
  width: calc(100% - 1rem);
  height: 100%;
  min-height: 2rem;
  max-height: 5rem;
  background-image: url(${(props) => props.image || ''});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
`;

export const ShareButtonContainer = styled.div`
  margin-top: 10px;
  text-align: right;
  @media (max-width: 576px) {
    text-align: left;
  }
`;
